import { useScopedUrlState, URL_STATE_PREFIX } from 'features/scoped_url_state'


export const useShareable = () => useScopedUrlState(URL_STATE_PREFIX.SHAREABLE)
